import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { useParams } from 'react-router-dom'
import Instagram from '../../components/Instagram/Instagram';
import Footer from '../../components/footer/Footer';
import Team from '../../api/Team'
import Logo from '../../images/logo.png'

const TeamSinglePage = (props) => {
    const { slug } = useParams()

    const TeamDetails = Team.find(item => item.slug === slug)

    const SubmitHandler = (e) => {
        e.preventDefault()
    }

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }


    return (
        <Fragment>
            <Navbar hclass={'header-style-1'} Logo={Logo} btnClass={'theme-btn-s1'} />
            <PageTitle pageTitle={TeamDetails.name} pagesub='Team' />
            <section className="team-sigle-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-4 col-12">
                            <div className="team-single-sidebar">
                                <div className="widget attorney-widget">
                                    <h3>Our team</h3>
                                    <ul>
                                        {Team.map((attorney, aitem) => (
                                            <li key={aitem}><Link onClick={ClickHandler} to={`/team-single/${attorney.slug}`}>{attorney.name}</Link></li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col col-lg-8 col-12">
                            <div className="attorney-single-content">
                                <div className="attorney">
                                    <div style={TeamDetails.imgSize === '6' ? {width: '550px', height: '500px'} : {}} className="img-holder">
                                        <img src={TeamDetails.DefImg === '' ? TeamDetails.AtImg : TeamDetails.DefImg} alt="" />
                                    </div>
                                    <div className="attorney-single-info">
                                        <div className="info">
                                            <h3>{TeamDetails.name}</h3>
                                            <span>{TeamDetails.title}</span>
                                            <ul>
                                                {/*<li><i className="ti-mobile"></i><span>Phone: </span>658-85851-8747</li>*/}
                                                <li><i className="ti-email"></i><span>Email: </span>{TeamDetails.email}</li>
                                                <li><i className="ti-timer"></i><span>Experience: </span>{TeamDetails.experience}</li>
                                                <li><i className="ti-location-pin"></i><span>Address: </span>
                                                    </li>
                                            </ul>
                                        </div>
                                        <div className="social">
                                            <ul>
                                                <li>
                                                    <a
                                                        href="https://www.instagram.com/loveofheartsfoundation/"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <i className="ti-instagram"></i>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        href="https://www.facebook.com/loveofheartsfoundation"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <i className="ti-facebook"></i>
                                                    </a>
                                                </li>
                                            </ul>

                                        </div>
                                    </div>
                                </div>
                                <div className="attorney-details">
                                    <h1>About {TeamDetails.name.split(' ')[0]}</h1>
                                    {TeamDetails.about}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/*<Instagram/>*/}
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default TeamSinglePage;
